<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" xl="2">
        <v-autocomplete
          v-model="name"
          :items="clientNames"
          item-text="clientName"
          label="Name"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2">
        <InvoiceFrequenciesDropDownList
          :id="invoiceFrequencyId"
          @change="handleInvoiceFrequencyChange"
        ></InvoiceFrequenciesDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <ThirdPartyPortalsDropDownList
          :id="thirdPartyPortalId"
          :isRequired="false"
          :disabled="false"
          :readonly="false"
          @ThirdPartyPortalIdChange="(newValue) => this.thirdPartyPortalId = newValue"
        ></ThirdPartyPortalsDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-switch
          class="my-auto"
          v-model="includeInactive"
          label="Include Inactive"
          @change="handleSearchClick"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" md="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { YesNoDropDownList } from '@/components/shared/yesNoLists'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { InvoiceFrequenciesDropDownList } from '@/components/invoiceFrequencies'
import ThirdPartyPortalsDropDownList from '@/components/clients/ThirdPartyPortalsDropDownList'

export default {
  components: {
    YesNoDropDownList,
    FilterButtons,
    FilterButtonsSmall,
    InvoiceFrequenciesDropDownList,
    ThirdPartyPortalsDropDownList
  },
  props: [
    'clientNames'
  ],
  computed: {
    ...mapFields('clientFilters', [
      'name',
      'active',
      'invoiceFrequencyId',
      'thirdPartyPortalId',
      'includeInactive'
    ])
  },
  methods: {
    ...mapActions('clientFilters', [
      'clearFilters'
    ]),
    handleActiveChange (value) {
      this.active = value
    },
    handleSearchClick () {
      this.$emit('search')
    },
    handleInvoiceFrequencyChange (value) {
      this.invoiceFrequencyId = value
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
